import { Reducer } from "redux";

import { UserByClaimsResponse } from "../models/api/User";
import { UserByClaimsActionDispatchTypes } from "../constants/User";
import { UserByClaimsActionTypes } from "../models/dispatchTypes/User";

export const userByClaimsDefaultData = {
  identifier: "",
  email: "",
  phoneNumber: "",
  firstName: "",
  lastName: "",
};

const initialState: UserByClaimsResponse = {
  loading: false,
  response: userByClaimsDefaultData,
  error: null,
};

const UserByClaimsReducer: Reducer<
  UserByClaimsResponse,
  UserByClaimsActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UserByClaimsActionDispatchTypes.GET_USER_BY_CLAIMS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UserByClaimsActionDispatchTypes.GET_USER_BY_CLAIMS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UserByClaimsActionDispatchTypes.GET_USER_BY_CLAIMS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case UserByClaimsActionDispatchTypes.GET_USER_BY_CLAIMS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UserByClaimsReducer;
